module.exports = __webpack_public_path__ + "img/lareverde.961961a.svg";